import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { MileageUOMEnum } from 'src/app/_models';

@Component({
    selector: 'formly-display',
    templateUrl: "./formly-display.component.html",
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class FormlyDisplayComponent extends FieldType implements OnInit {
    fieldKey: string;
    nrAvailableDistance: any;
    get mileageUOMEnum() {
        return MileageUOMEnum;
    }

    constructor() {
        super();
    }

    ngOnInit() {
        if (this.field.key) { this.fieldKey = this.field.id ?? this.field.key.toString(); }
        if (this.model.mileage) {
            if (this.model.mileage && this.model.mileage.nrAvailableDistance) {
                this.model.mileage.nrAvailableDistance = parseFloat(this.model.mileage.nrAvailableDistance).toFixed(2).toString();
            }
            else {
                this.model.mileage.nrAvailableDistance = "0.00";
            }
        }
    }
}
